// @ is an alias to /src
import CategoryItem from '@/components/CategoryItem.vue'

import {
    MDBBtn,  
    MDBCard,
    MDBCardBody,
    MDBCardTitle,
    MDBCardText,
    MDBCardLink,
    MDBCardImg,    
    MDBListGroupItem,
    MDBListGroup 

} from "mdb-vue-ui-kit";

export default {

  name: 'Category',
  components: {
    CategoryItem,

    MDBBtn,  
    MDBCard,
    MDBCardBody,
    MDBCardTitle,
    MDBCardText,
    MDBCardLink,
    MDBCardImg,   
    MDBListGroupItem,
    MDBListGroup
  },
  data() {
    return {            
      
    };
  },
  mounted(){           
    
  },
  methods:{                
    

  }
}

